import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "Qu'est-ce que Clan ?",
    answer: "Clan est une application moderne d'organisation familiale qui réunit calendrier partagé, gestion des tâches et carnet de contacts dans un seul espace. Elle permet à toute la famille de rester synchronisée et organisée au quotidien."
  },
  {
    question: "Comment fonctionne Clan ?",
    answer: "Après votre inscription, vous créez votre famille et invitez les membres. Chacun peut ensuite ajouter des événements au calendrier partagé, créer des tâches, gérer les contacts familiaux et consulter les informations en temps réel depuis n'importe quel appareil."
  },
  {
    question: "Combien coûte Clan ?",
    answer: "Clan est gratuit pour une personne. Pour un usage partagé et synchronisé en famille, l'abonnement est à 4,99€ par mois et par famille. Une option annuelle à 49€ par an est également disponible, vous permettant d'économiser deux mois."
  },
  {
    question: "Combien de membres peuvent rejoindre une famille ?",
    answer: "Il n'y a pas de limite au nombre de membres dans une famille. Vous pouvez inviter autant de personnes que nécessaire : parents, enfants, grands-parents, et même proches de confiance."
  },
  {
    question: "Mes données sont-elles sécurisées ?",
    answer: "Absolument. Toutes vos données sont chiffrées et stockées de manière sécurisée. Nous ne partageons jamais vos informations personnelles avec des tiers. Chaque famille dispose de son propre espace privé et protégé."
  },
  {
    question: "Puis-je utiliser Clan sur plusieurs appareils ?",
    answer: "Oui ! Clan fonctionne sur smartphone iOS, tablette et ordinateur. La version Android arrive très bientôt. Toutes vos données sont synchronisées en temps réel sur tous vos appareils."
  },
  {
    question: "Comment inviter des membres à ma famille ?",
    answer: "Depuis l'application, accédez aux paramètres de votre famille et utilisez la fonction d'invitation. Vous pouvez envoyer des invitations par email. Les invités recevront un lien pour rejoindre votre famille."
  },
  {
    question: "Puis-je synchroniser Clan avec Google Calendar ?",
    answer: "Oui, Clan peut se synchroniser avec Google Calendar pour importer vos événements existants et garder vos calendriers à jour automatiquement. La configuration se fait en quelques clics depuis les paramètres."
  },
  {
    question: "Comment fonctionne la gestion des tâches ?",
    answer: "Vous pouvez créer des listes de tâches partagées, assigner des tâches à des membres spécifiques, définir des dates d'échéance et suivre la progression. Chacun reçoit des notifications pour ses tâches assignées."
  },
  {
    question: "Que se passe-t-il si je veux annuler mon abonnement premium ?",
    answer: "Vous pouvez annuler votre abonnement premium à tout moment depuis les paramètres de votre compte. Vous conserverez l'accès aux fonctionnalités premium jusqu'à la fin de votre période payée, puis votre compte repassera automatiquement en version gratuite."
  },
  {
    question: "Proposez-vous des remboursements ?",
    answer: "Oui, nous offrons une garantie satisfait ou remboursé de 14 jours sur tous nos abonnements. Si vous n'êtes pas satisfait, contactez notre support et nous procéderons au remboursement intégral."
  },
  {
    question: "Comment gérer ma facturation et mes paiements ?",
    answer: "Vous pouvez consulter votre historique de facturation, modifier votre moyen de paiement et télécharger vos factures directement depuis l'administration du clan dans les paramètres."
  },
];

export function LandingFAQ() {
  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
            Questions fréquentes
          </h2>
          <p className="text-lg text-muted-foreground">
            Tout ce que vous devez savoir sur Clan
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-card border border-border rounded-lg px-6 data-[state=open]:shadow-md transition-shadow"
              >
                <AccordionTrigger className="text-left hover:no-underline py-5">
                  <span className="font-semibold text-base pr-4">
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-5 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
